import { Button } from "@spz/ui/components/button";
import { SearchBar } from "@spz/ui/components/search-bar";
import { Table } from "@spz/ui/components/table";
import { DataTableBody } from "@spz/ui/components/table/data-table-body";
import { DataTableHeader } from "@spz/ui/components/table/data-table-header";
import { DataTablePagination } from "@spz/ui/components/table/data-table-pagination";
import type { FC } from "react";
import { Navigate } from "react-router";
import { useUserGroupsListViewModel } from "../../features/management-settings/view-models/use-user-groups-list-viewmodel";

const UserGroupsTab: FC = () => {
  const {
    t,
    hasUserGroupsManagementPermission,
    isLoading,
    onSearch,
    table,
    openCreateUserGroupDialog,
  } = useUserGroupsListViewModel();

  if (!hasUserGroupsManagementPermission) {
    return <Navigate to="/403" replace />;
  }

  return (
    <>
      <div className="flex justify-between">
        <div className="w-1/2 max-w-[344px]">
          <SearchBar
            onSearch={onSearch}
            placeholder={t("search_user_group_placeholder")}
          />
        </div>

        <Button onClick={openCreateUserGroupDialog}>
          {t("create_new_group")}
        </Button>
      </div>

      <div className="mt-4">
        <Table className="overflow-auto w-full border-collapse border-spacing-0 bg-white">
          <DataTableHeader table={table} />
          <DataTableBody table={table} isLoading={isLoading} />
        </Table>
        <DataTablePagination
          table={table}
          entityLabel="pagination_entity_user_groups"
          isLoading={isLoading}
        />
      </div>
    </>
  );
};

export default UserGroupsTab;
